import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
  Grid,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "./FAQ.module.css";
import { Helmet } from "react-helmet";

const FAQ = () => {
  const faqData = [
    {
      question: "What is an AI Selfie Generator?",
      answer:
        "The AI Selfie Generator is a tool that uses artificial intelligence to create, enhance, or transform selfies. It can generate realistic or stylized selfies, apply filters, and even create avatars or artistic versions of your photos.",
    },
    {
      question: "What types of selfies can I create with this AI?",
      answer:
        "You can create a variety of selfies, including realistic portraits, cartoon avatars, fantasy characters, and stylized versions of yourself. The AI also supports adding creative effects, backgrounds, and themes.",
    },
    {
      question: "How does the AI generate selfies?",
      answer:
        "The AI analyzes your uploaded photo and uses advanced algorithms to generate new selfies based on your input. You can customize the style, theme, and effects to create unique results.",
    },
    {
      question: "Can I customize the generated selfies?",
      answer:
        "Yes, you can customize the selfies by choosing different styles, themes, and effects. You can also adjust details like hair color, background, and facial features to match your preferences.",
    },
    {
      question: "How long does it take to generate a selfie?",
      answer:
        "Generation time typically ranges from 5 to 20 seconds, depending on the complexity of the request and server load.",
    },
    {
      question: "What file formats are supported for upload and download?",
      answer:
        "We support common image formats like JPEG and PNG for uploads. Generated selfies can be downloaded in high-resolution formats, including JPEG and PNG.",
    },
    {
      question: "Can I use the generated selfies commercially?",
      answer:
        "Yes, all selfies generated with our platform are royalty-free and can be used for personal or commercial purposes, including social media, marketing, and branding.",
    },
    {
      question: "Does the AI work with group selfies?",
      answer:
        "Yes, the AI can process group selfies and generate enhanced or stylized versions for each person in the photo.",
    },
    {
      question: "Is my data safe when using the AI Selfie Generator?",
      answer:
        "Absolutely. We prioritize user privacy and data security. Uploaded photos are processed securely and are not stored on our servers after the generation is complete.",
    },
    {
      question: "What resolutions are supported for generated selfies?",
      answer:
        "We support resolutions from standard sizes (e.g., 512x512) up to 4K UHD (3840x2160). Higher resolutions may require premium credits or subscriptions.",
    },
    {
      question: "Can I generate multiple selfies at once?",
      answer:
        "Yes, our platform supports batch processing, allowing you to upload and generate multiple selfies simultaneously for faster results.",
    },
  ];

  // Create schema markup for FAQ
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqData.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <Container maxWidth="lg" className={styles.container}>
      <Helmet>
        {/* Structured Data */}
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>
      <Typography variant="h2" className={styles.heading}>
        Frequently Asked Questions
      </Typography>
      <Typography variant="h6" className={styles.subheading}>
        Can't find the answer you're looking for? Reach out to our customer
        support team
      </Typography>

      <Grid item xs={12} md={8}>
        {faqData.map((faq, index) => (
          <Accordion key={index} className={styles.accordion}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className={styles.expandIcon} />}
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
            >
              <Typography className={styles.question}>
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={styles.answer}>{faq.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Grid>
    </Container>
  );
};

export default FAQ;
